import React from 'react';

const PandaSVG = ({ color }) => (
    <svg width="60px" height="60px" viewBox="0 0 24 24" strokeWidth="2.1" fill="none" xmlns="http://www.w3.org/2000/svg" color={color}>
        <path 
            d="M5.81249 7C5.81249 7 5.35861 7.62759 4.81552 8.66667M18.1875 7C18.1875 7 18.6414 7.62759 19.1845 8.66667M4.81552 8.66667C4.0067 10.2142 3 12.6743 3 15.3333C5.8125 15.3333 7.49999 17 7.49999 17C7.49999 17 8.62499 22 12 22C15.375 22 16.5 17 16.5 17C16.5 17 18.1875 15.3333 21 15.3333C21 12.6743 19.9933 10.2142 19.1845 8.66667M4.81552 8.66667C4.81552 8.66667 1.875 6.44436 4.81552 2C5.81249 2.55556 8.625 4.77778 8.625 4.77778C8.625 4.77778 10.3125 3.66667 12 3.66667C13.6875 3.66667 15.375 4.77778 15.375 4.77778C15.375 4.77778 18.1875 2.55556 19.3125 2C22.125 6.44456 19.1845 8.66667 19.1845 8.66667"
            stroke={color} strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round"
        />
        <path 
            d="M11 18L12 18M13 18L12 18M12 18L12 19" 
            stroke={color} strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round"
        />
        <path 
            d="M8.5 12.5L10 14" 
            stroke={color} strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round"
        />
        <path 
            d="M15.5 12.5L14 14" 
            stroke={color} strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round"
        />
    </svg>
);

export default PandaSVG;
